import { HOST } from '../../../utils/env'
import getImageRenditions from '../../../utils/getImageRenditions'

async function getPuffs({ programmeGuid }) {
  try {
    const url = `https://strapi.cms.${HOST}/api/puffs?filters[Enabled]=true&filters[guid][guid]=${programmeGuid}&populate=deep`
    // fetch puffs
    const response = await fetch(url)
    const json = await response.json()
    return json.data.map(puff => remapPuffs(puff))
  } catch (e) {
    return null
  }
}

function remapPuffs(result) {
  return {
    id: result?.attributes?.Image?.data?.id,
    title: result?.attributes?.Title,
    link: result?.attributes?.Link,
    image: getImageRenditions(result?.attributes?.Image?.data?.attributes?.url, ['264x149']),
  }
}

export default getPuffs
